<hb-modal-dialog [heading]="'Widgets.WidgetConfiguration' | i18next" [noOverflow]="noModalOverflow" [showFooter]="false">
  <div content class="form-container">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="form-control-label">{{'Widgets.Title' | i18next}}</label>
          <input type="text" [(ngModel)]="widgetConfigService.dashboardWidgetTitle" class="form-control" />
        </div>

        <div class="form-group" *ngIf="dashboardWidget.widget.widgetDataType === widgetDataTypeEnum.MitigationsDueByMonth">
          <div class="row">
            <div class="col-6">
              <label class="form-control-label" for="dateRangeStart">{{'Widgets.SDate' | i18next}}</label>
            </div>
            <div class="col-6">
              <label class="form-control-label" for="dateRangeEnd">{{"Widgets.EDate" | i18next}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <hb-datepicker-control
                name="dateRangeStart"
                [(ngModel)]="dateRangeStartValue"
                [placeholderText]="'Widgets.StartDate' | i18next"
                controlId="dateRangeStart"
                #dateRangeStart="ngModel"
                required
              ></hb-datepicker-control>
              <div *ngIf="!dateRangeStartValue" class="invalid-feedback">
                {{'Widgets.StartDateIsRequired.' | i18next}}
              </div>
            </div>
            <div class="col-6">
              <hb-datepicker-control
                name="dateRangeEnd"
                [(ngModel)]="dateRangeEndValue"
                [placeholderText]="'Widgets.EndDate' | i18next"
                controlId="dateRangeEnd"
                #dateRangeEnd="ngModel"
                required
              ></hb-datepicker-control>
              <div *ngIf="!dateRangeEndValue" class="invalid-feedback">
                {{'Widgets.EndDateIsRequired' | i18next}}
              </div>
              <div *ngIf="!(dateRangeEndValue | widgetDateRangeValidator: dateRangeStartValue:dashboardWidget)" class="invalid-feedback">
                {{'Widgets.EndDateMustBeGreaterThanStartDate' | i18next}}
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" [ngClass]="{ 'tree-view-restrict-height': noModalOverflow }">
          <label class="form-control-label">{{'Widgets.HierarchySelection' | i18next}}</label>
          <p-tree
            [value]="widgetConfigService?.hierarchyNodes"
            selectionMode="checkbox"
            [(selection)]="widgetConfigService.selectedHierarchyNodes"
            [propagateSelectionUp]="true"
          ></p-tree>
          <div *ngIf="!widgetConfigService.isSelectedHierarchyValid()" class="invalid-feedback">
            {{ 'dashboard.widget.dialog.selectOneSiteOrLocation' | translateTerminology }}
          </div>
        </div>

        <div class="form-group" *ngIf="dashboardWidget.widget.widgetDataType === widgetDataTypeEnum.RiskDistribution">
          <label class="form-control-label">{{'Widgets.DistributionType' | i18next}}</label>

          <div class="row">
            <div class="col">
              <label class="form-control-label" for="RiskBandRadio" [title]="'Widgets.RiskBand' | i18next">
                <input
                  type="radio"
                  name="riskdistributionGroup"
                  id="RiskBandRadio"
                  [value]="riskDistributionParameterType.RiskBand"
                  [(ngModel)]="widgetConfigService?.riskDistributionParameter.intValue"
                />&nbsp;{{'Widgets.RiskBand' | i18next}}
              </label>
            </div>
            <div class="col">
              <label class="form-control-label" for="POFRadio" [title]="'Widgets.ProbabilityOfFailure' | i18next">
                <input
                  type="radio"
                  name="riskdistributionGroup"
                  id="POFRadio"
                  [value]="riskDistributionParameterType.Pof"
                  [(ngModel)]="widgetConfigService?.riskDistributionParameter.intValue"
                />&nbsp;PoF
              </label>
            </div>
            <div class="col">
              <label class="form-control-label" for="COFRadio" [title]="'Widgets.ConsequenceOfFailure' | i18next">
                <input
                  type="radio"
                  name="riskdistributionGroup"
                  id="COFRadio"
                  [value]="riskDistributionParameterType.Cof"
                  [(ngModel)]="widgetConfigService?.riskDistributionParameter.intValue"
                />&nbsp;{{'Widgets.COF' | i18next}}
              </label>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="dashboardWidget.widget.widgetDataType === widgetDataTypeEnum.PlannedMaintenanceImprovements">
          <label class="form-control-label">{{'Widgets.OptimizationMethodology' | i18next}}</label>
          <div class="row">
            <div class="col-12">
              <p-dropdown
                class="form-control hb-dropdown hb-prime-dropdown"
                [options]="optimizationTypes"
                id="widgetOptimizationMethodologyFilter"
                [filter]="true"
                [virtualScroll]="false"
                [showClear]="true"
                [(ngModel)]="selectedOptimizationType"
                (onChange)="optimzationTypeChanged($event.value)"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div footerContent>
    <div class="pull-left width-50">
      <button
        type="button"
        class="btn btn-primary"
        (click)="apply()"
        [disabled]="
          !widgetConfigService.isSelectedHierarchyValid() || !(dateRangeEndValue | widgetDateRangeValidator: dateRangeStartValue:dashboardWidget)
        "
      >
        {{'Widgets.Apply' | i18next}}
      </button>
    </div>
    <div class="pull-right width-50 text-right">
      <button type="button" class="btn btn-default" (click)="delete()" style="margin: 0 5px;">
        <i class="fa fa-trash" aria-hidden="true" style="padding-right: 9px;"></i>{{'Widgets.Delete' | i18next}}
      </button>
      <button type="button" class="btn btn-default" (click)="cancel()">{{'Widgets.Cancel' | i18next}}</button>
    </div>
  </div>
</hb-modal-dialog>
